<div class="color-picker-container">
  <div class="color-picker">
    <input type="color" [(ngModel)]="colorModel" [disabled]="disabled" />
  </div>
  <div class="swatch" [style.background-color]="colorModel"></div>
  <input
    class="color-hex"
    type="text"
    [(ngModel)]="colorModel"
    [disabled]="disabled"
  />
</div>
